import { ApiGatewayApi } from "api";
import { addNotification, loading } from "layouts/AppLayout/modules";
import { put, takeEvery } from "redux-saga/effects";
import * as Actions from "../actions/AuthResendVerificationEmail";
import { CredentialsProvider } from "./CredentialsProvider";

export function* resendVerificationEmail(action: Actions.AuthResendVerificationEmailAction) {
    const { credentials } = action.payload;
    let caughtError: Error;
    try {
        const api =  new ApiGatewayApi(new CredentialsProvider(credentials));
        yield put(loading(true, action));
        yield api.resendVerificationEmail();
        yield put(addNotification("Email request sent."));
    } catch (e) {
        caughtError = e;
        yield put(addNotification(e.message, true));
    } finally {
        yield put(loading(false, action));
        yield put(Actions.resendVerificationEmailEnd(caughtError));
    }
}

export function* watchResendVerificationEmail() {
    yield takeEvery(Actions.AUTH_RESEND_VERIFICATION_EMAIL, resendVerificationEmail);
}